import { createSlice } from '@reduxjs/toolkit';

const listingsFilter = JSON.parse(localStorage.getItem('listingsFilter'));
const projectsFilter = JSON.parse(localStorage.getItem('projectsFilter'));
const interestsFilter = JSON.parse(localStorage.getItem('interestsFilter'));
const tasksFilter = JSON.parse(localStorage.getItem('tasksFilter'));

const initialState = {
  allBrokers: [],
  allCategories: [],
  allOwners: [],
  allListing: [],
  allUsers: [],
  allTaskManagerTemplate: [],
  allEmailTemplates: [],
  hasNotification: false,
  onlyMyTasks: false,
  listingsFilter: {
    search: listingsFilter?.search || '',
    status: listingsFilter?.status || [],
    broker: listingsFilter?.broker || { _id: 'null', email: 'All' },
    category: listingsFilter?.category || { _id: 'null', name: 'All' },
    leadSource: listingsFilter?.leadSource || { value: 'null', label: 'All' },
    min: listingsFilter?.min || 0,
    max: listingsFilter?.max || 0,
  },
  projectsFilter: {
    search: projectsFilter?.search || '',
    status: projectsFilter?.status || [],
    broker: projectsFilter?.broker || { _id: 'null', email: 'All' },
  },
  interestsFilter: {
    search: interestsFilter?.search || '',
    status: interestsFilter?.status || { value: 'all', label: 'All' },
    leadProgress: interestsFilter?.leadProgress || {
      value: 'all',
      label: 'All',
    },
    broker: interestsFilter?.broker || { _id: 'null', email: 'All' },
    company: interestsFilter?.company || null,
  },
  tasksFilter: {
    assignee: tasksFilter?.assignee || { _id: 'null', email: 'All' },
    owner: tasksFilter?.owner || { _id: 'null', email: 'All' },
    company: tasksFilter?.company || { _id: 'null', email: 'All' },
    search: {
      dueToday: tasksFilter?.search?.dueToday || '',
      dueThisWeek: tasksFilter?.search?.dueThisWeek || '',
      dueThisMonth: tasksFilter?.search?.dueThisMonth || '',
      overDue: tasksFilter?.search?.overDue || '',
    },
  },
};

const commonSlice = createSlice({
  name: 'commonSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setEmailTemplates(state, action) {
      state.allEmailTemplates = action.payload;
    },
    setAllCommon(state, action) {
      state.allBrokers = action.payload?.allBrokers;
      state.allCategories = action.payload?.allCategories;
      state.allOwners = action.payload?.allOwners;
      state.allListing = action.payload?.allListing;
      state.allUsers = action.payload?.allUsers;
      state.allTaskManagerTemplate = action.payload?.allTaskManagerTemplate;
      state.allEmailTemplates = action.payload?.allEmailTemplates;
    },
    setHasNotification: (state, action) => {
      state.hasNotification = action.payload.data;
    },
    setOnlyMyTasks: (state, action) => {
      state.onlyMyTasks = action.payload;
    },
    setListingsFilter: (state, action) => {
      state.listingsFilter = action.payload;
      localStorage.setItem('listingsFilter', JSON.stringify(action.payload));
    },
    setProjectsFilter: (state, action) => {
      state.projectsFilter = action.payload;
      localStorage.setItem('projectsFilter', JSON.stringify(action.payload));
    },
    setInterestsFilter: (state, action) => {
      state.interestsFilter = action.payload;
      localStorage.setItem('interestsFilter', JSON.stringify(action.payload));
    },
    setTasksFilter: (state, action) => {
      state.tasksFilter = action.payload;
      localStorage.setItem('tasksFilter', JSON.stringify(action.payload));
    },
  },
});

export const {
  setAllCommon,
  setEmailTemplates,
  setHasNotification,
  setOnlyMyTasks,
  setListingsFilter,
  setProjectsFilter,
  setInterestsFilter,
  setTasksFilter,
} = commonSlice.actions;

export default commonSlice.reducer;
